import { CssBaseline, Paper, Tooltip, Button } from "@mui/material";

import Container from "../../components/custom/Container";
import GlobalStyle from "../../components/GlobalStyle";
import Logo from "../../components/custom/Logo";
import { Outlet } from "react-router-dom";
import React from "react";
import bg from "../../assets/bgs/kindle.jpg";
import styled from "styled-components/macro";
// import LanguagesDropdown from "../../components/custom/LanguagesDropdown.js";
import ThemeSwitch from "../../components/custom/ThemeSwitch/index";

import { Box } from "@mui/system";
import HelpIcon from "../../components/custom/Icons/Help";
import { HELP_MAP, HELP_HOME } from "../../constants/generalConstants";
// import breakpoints from "../../theme/breakpoints";

const Root = styled.div`
  background-image: url(${bg});

  background: linear-gradient(
      ${(props) => props.theme.palette.authBg.background},
      ${(props) => props.theme.palette.authBg.background}
    ),
    url(${bg});
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;

  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-top: ${(props) => props.theme.spacing(3)};
    padding-bottom: ${(props) => props.theme.spacing(3)};
    padding-left: ${(props) => props.theme.spacing(3)};
    padding-right: ${(props) => props.theme.spacing(3)};
  }
  padding-top: ${(props) => props.theme.spacing(5)};
  padding-bottom: ${(props) => props.theme.spacing(5)};
  padding-left: ${(props) => props.theme.spacing(10)};
  padding-right: ${(props) => props.theme.spacing(10)};
`;
const Wrapper = styled(Paper)`
  ${(props) => props.theme.breakpoints.down("sm")} {
    max-width: 100%;
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    max-width: 100%;
  }
  background-color: transparent;
  background-image: none;
  max-width: 50%;
  height: 100%;
`;

const StyledContainer = styled(Container)`
  display: flex;
  ${(props) => props.theme.breakpoints.down("sm")} {
    max-width: 100%;
    flex-direction: column;
  }
  flex-direction: row;
  height: 100%;
  overflow: hidden;
`;
const StyledDiv = styled.div`
  background-color: "transparent";
  width: 105px;
  height: 105px;
  padding: 10px;
  //border-radius: 3.75rem;
  align-content: center;
  align-items: center;
  flex-direction: row;
  display: flex;
  //box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
`;

const StyledLogoLeftColumnWrapper = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media screen and (max-width: 700px) {
    flex-direction: row;
  }
`;

const LanguagesDropdownWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10%;
  @media screen and (max-width: 700px) {
    margin-left: 5%;
    margin-top: 0;
    flex-direction: row;
    width: 20%;
    justify-content: space-between;
  }
`;

const Auth = ({ children }) => {
  const openHelp = () => {
    window.open(
      HELP_MAP?.[window.location.pathname]
        ? HELP_MAP?.[window.location.pathname]
        : HELP_MAP?.[HELP_HOME],
      "_blank"
    );
  };
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <React.Fragment>
        <Wrapper>
          <StyledContainer>
            <StyledLogoLeftColumnWrapper>
              <StyledDiv>
                <Logo />
              </StyledDiv>
              <Tooltip placement="bottom" title="Help">
                <Button onClick={() => openHelp()}>
                  <HelpIcon />
                </Button>
              </Tooltip>
              <LanguagesDropdownWrapper>
                {/* <LanguagesDropdown /> */}
                <ThemeSwitch />
              </LanguagesDropdownWrapper>
            </StyledLogoLeftColumnWrapper>
            {children}
            <Outlet />
          </StyledContainer>
        </Wrapper>
      </React.Fragment>
    </Root>
  );
};

export default Auth;
